// import axios from 'axios';
import { ajaxGet, getAjaxModal } from 'lib/ajax-helpers';
import Cookies from 'js-cookie';
import { featureEnabled, isSafari } from 'lib/helpers';
import EzUser from 'init/init-user';

export function forceDownload(blob, filename) {
  const a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  // For Firefox https://stackoverflow.com/a/32226068
  document.body.appendChild(a);
  a.click();
  a.remove();
}

// Current blob size limit is around 500MB for browsers
export function downloadResource({
  url, filename, downloadSize = 'original', reloadPage = false,
}) {
  const makeFilename = () => {
    let fn;

    if (!filename) fn = url.split('\\').pop().split('/').pop();

    fn = downloadSize !== 'original' ? `${downloadSize}-${fn}` : fn;

    return fn;
  };

  const reloadAfterDl = () => {
    window.setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  if (featureEnabled('customer_feedback')) {
    const curDownloadCount = parseInt(Cookies.get('download_count'), 10) || 0;

    Cookies.set('download_count', curDownloadCount + 1);
  }

  if (downloadSize === 'original') {
    // if we're reloading the page after the download, we need to
    // open the file download url in a new "tab" for some reason.
    if (reloadPage) {
      window.open(url, '_blank');

      reloadAfterDl();
    } else {
      window.location.href = url;
    }
  } else {
    ajaxGet(url,
      (response) => {
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], { type });
        const blobUrl = window.URL.createObjectURL(blob);

        forceDownload(blobUrl, makeFilename());

        if (reloadPage) reloadAfterDl();
      },
      (error) => console.error(error), {},
      {
        headers: {},
        mode: 'cors',
        responseType: 'blob',
      });
  }
}

/* eslint-disable consistent-return */
export function getCustomerFeedbackModal({
  onReload = false,
  manualTrigger = false,
} = {}) {
  if (!featureEnabled('customer_feedback')) return false;
  if (!EzUser.signedIn) return false;
  if (EzUser.feedbackProvided) return false;

  // Need to add long delay for Safari, so modal request does not conflict
  // with file download. If the user navigates away before modal is shown, we
  // will show the modal on next page load, via the page_load_feedback_modal cookie
  const modalDelay = (isSafari() && !manualTrigger) ? 30000 : 0;

  setTimeout(() => { // set a timeout to make sure any pending downloads are counted
    const curDownloadCount = parseInt(Cookies.get('download_count'), 10) || 0;

    if (curDownloadCount === 5 || curDownloadCount === 15) {
      Cookies.set('page_load_feedback_modal', true);

      setTimeout(() => {
        if (!onReload) {
          const { customerFeedbackModalPath } = document.body.dataset;

          getAjaxModal(customerFeedbackModalPath);
        }
      }, modalDelay);
    }
  });
}
/* eslint-enable consistent-return */

export const showReturningSigninModal = () => {
  if (Cookies.get('returning_signin_denied')) return false;
  if (document.querySelector('#signup-modal')) return false;
  if (EzUser.signedIn) return false;

  const newUserStatus = (statusType) => {
    if (!statusType) return true;

    return statusType.includes('new');
  };

  if (!newUserStatus(Cookies.get('user_status-start'))
      || !newUserStatus(Cookies.get('user_status-seen'))
      || !newUserStatus(Cookies.get('user_status-updated'))) return true;

  return false;
};
